"use client"

import React from "react";
import Image from "next/image";
import Tilt from "react-parallax-tilt";
import { FormattedMessage } from "react-intl";

import mainScreenPost from "@/assets/images/media/main-screen-post.png";
import dashboardClick from "@/assets/images/media/dashboard-click.png";
import dashboardVisitors from "@/assets/images/media/dashboard-visitors.png";

import StartCustomDomain from "../StartCustomDomain";

const CallToAction = () => (
  <section id="cta" className="relative z-10 pt-[110px]">
    <div className="container max-w-[1390px]">
      <div className="px-10 bg-white rounded-2xl pt-14 shadow-card dark:bg-dark dark:shadow-card-dark sm:px-20 lg:px-12 lg:py-20 xl:px-20">
        <div className="flex flex-wrap -mx-4">
          <div className="self-center w-full px-4 lg:w-1/2">
            <div className="wow fadeInUp mx-auto max-w-[530px] text-center lg:ml-0 lg:text-left" data-wow-delay=".2s">
              <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[38px] md:leading-tight">
                <FormattedMessage
                  id="home-page-hero-call-to-action-title"
                  values={{
                    span: (...chunks) => (
                      <span
                        key={1}
                        className="inline text-transparent bg-gradient-2 bg-clip-text"
                      >
                        {React.Children.toArray(chunks)}
                      </span>
                    ),
                    br: () => <br key={0} />,
                  }}
                />
              </h2>
              <p className="mb-10 text-base text-body">
                <FormattedMessage
                  id="home-page-hero-call-to-action-body-text"
                />
              </p>
              <div className="-mx-[10px] flex flex-wrap items-center justify-center lg:justify-start">
                <StartCustomDomain />
              </div>
            </div>
          </div>

          <div className="w-full px-4 lg:w-1/2">
            <div className="wow fadeInUp relative z-10 mx-auto mt-20 max-w-[435px] lg:mt-0" data-wow-delay=".3s">
              <Tilt>
                <Image
                  priority={true}
                  src={mainScreenPost}
                  width={300}
                  height={800}
                  alt="Downfor profile page example"
                  title="Downfor profile page example"
                  className="max-w-full mx-auto"
                />
              </Tilt>
              <div
                className="absolute left-0 right-0 w-full rounded-full -top-5 -z-10 aspect-square bg-gradient-2"
                style={{
                  alignSelf: "anchor-center"
                }}
              ></div>
              <div className="absolute top-10 right-0 z-10">
                <Image
                  src={dashboardClick}
                  width={120}
                  height={40}
                  alt="Downfor profile page example slicks"
                  title="Downfor profile page example clicks"
                />
              </div>
              <div className="absolute bottom-20 left-0 z-10">
                <Image
                  src={dashboardVisitors}
                  width={120}
                  height={40}
                  alt="Downfor profile page example dasboard"
                  title="Downfor profile page example dasboard"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="absolute right-0 -top-[250px] -z-10">
      <svg width="610" height="1183" viewBox="0 0 610 1183" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.2" filter="url(#filter0_f_47_19)">
          <circle cx="591.5" cy="591.5" r="341.5" fill="url(#paint0_linear_47_19)" />
        </g>
        <defs>
          <filter id="filter0_f_47_19" x="0" y="0" width="1183" height="1183" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="125" result="effect1_foregroundBlur_47_19" />
          </filter>
          <linearGradient id="paint0_linear_47_19" x1="250" y1="250" x2="1057.46" y2="718.481" gradientUnits="userSpaceOnUse">
            <stop stopColor="#f55c00" />
            <stop offset="0.541667" stopColor="#ff9640" />
            <stop offset="1" stopColor="#80aaff" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <div className="absolute left-0 hidden top-10 -z-10 sm:block">
      <svg width="706" height="1405" viewBox="0 0 706 1405" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[400px] md:w-[700px]">
        <g opacity="0.25" filter="url(#filter0_f_47_21)">
          <circle cx="3.5" cy="702.5" r="442.5" fill="url(#paint0_linear_47_21)" />
        </g>
        <defs>
          <filter id="filter0_f_47_21" x="-699" y="0" width="1405" height="1405" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="130" result="effect1_foregroundBlur_47_21" />
          </filter>
          <linearGradient id="paint0_linear_47_21" x1="-545.385" y1="1145" x2="552.329" y2="380.732" gradientUnits="userSpaceOnUse">
            <stop stopColor="#f55c00" />
            <stop offset="0.541667" stopColor="#ff9640" />
            <stop offset="1" stopColor="#80aaff" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </section>
);

export default CallToAction;